<template>
  <div class="pb-5">
    <div class="jm-white-container">
      <div class="col-lg-10 mx-auto">
        <div class="row">
          <!-- <div class="col-md-12 mb-4">
            <div class="d-flex align-items-center">
              <label for="file-selector" class="file-selector w-100">
                <span v-if="filePath.length == 0">Backup Location Browse</span>
                <span v-else>{{ filePath }}</span>
                <input
                  type="file"
                  v-on:change="getfolder($event)"
                  webkitdirectory
                  mozdirectory
                  msdirectory
                  odirectory
                  directory
                  multiple
                  id="file-selector"
                  class="d-none"
                />
              </label>
              <Tooltip :title="`Select the folder where you want to store all backups for Brij`"  />
            </div>
            <p v-if="filePath.length == 0" class="error_msg">Provide a valid pathname</p>
          </div>-->

          <!--<div class="col-md-6 mb-4">
            <b-dropdown
              text="Restore Backup"
              variant="dropdown-curve-lg bg-theme-light"
              class="w-100"
            >
              <b-dropdown-item href="#">Action</b-dropdown-item>
              <b-dropdown-item href="#">Another action</b-dropdown-item>
              <b-dropdown-item href="#" v-for="(loop , key) in 20" :key="key">Something else here</b-dropdown-item>
            </b-dropdown>
          </div>-->
          <div class="col-md-12 px-0 mb-4">
            <h5 class="border-bottom pb-3">Backup Schedule</h5>
          </div>

          <div class="col-md-12 mb-4">
            <div class="row pb-3 border-bottom">
              <div class="col-md-7">
                <div class="d-flex align-items-center">
                  <div>Daily</div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="input-container">
                    <input
                      :disabled="!schedule.daily"
                      v-model="cronTimer.daily.time"
                      type="text"
                      placeholder="19:00"
                    />
                  </div>
                  <!-- <Tooltip :title="`Select the folder where you want to store all backups for Brij`" 
                  :src="`clock.svg`" /> -->
                  <Tooltip :title="`Select the folder where you want to store all backups for Brij`" 
                  :src="`clock.svg`" />
                </div>
                <p v-if="submitted && schedule.daily" class="error_message">{{ errmsg }}</p>
              </div>

              <div class="col-md-2">
                <div class="d-flex justify-content-center align-items-center">
                  <label class="ios-switch">
                    <input
                      id="name_1"
                      type="checkbox"
                      class="ios-checkbox"
                      v-on:change="onChangeStatus($event,'daily')"
                      v-model="schedule.daily"
                    />
                    <span class="switch-slider"></span>
                  </label>
                  <Tooltip :title="`Select time when you want daily backup to be scheduled`"  />
                </div>
              </div>
            </div>

            <div class="row py-3 border-bottom">
              <div class="col-md-4">
                <div class="d-flex">
                  <div>Weekly</div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label :class="selectedDay.length > 0 ? 'shift-up' : '' ">Select Day</label>
                    <b-dropdown
                      :disabled="!schedule.weekly"
                      :text="selectedDay"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        href="#"
                        v-for="(week, weekIndex) in cronTimer.weekly.weekArray"
                        :key="weekIndex"
                        v-on:click="onSelectDay($event, week,weekIndex);"
                      >{{ week.wd_day }}</b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <Tooltip :title="`Select the folder where you want to store all backups for Brij`" 
                  :src="`school-calendar.svg`" />
                </div>
                <p v-if="submitted && schedule.weekly" class="error_message">{{ errmsg }}</p>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="input-container">
                    <input
                      :disabled="!schedule.weekly"
                      v-model="cronTimer.weekly.time"
                      type="text"
                      placeholder="19:00"
                    />
                  </div>
                  <Tooltip :title="`Select the folder where you want to store all backups for Brij`" 
                  :src="`clock.svg`" />
                </div>
                <p v-if="submitted && schedule.weekly" class="error_message">{{ errmsg }}</p>
              </div>

              <div class="col-md-2">
                <div class="d-flex justify-content-center align-items-center">
                  <label class="ios-switch">
                    <input
                      id="name_2"
                      type="checkbox"
                      class="ios-checkbox"
                      v-on:change="onChangeStatus($event,'weekly')"
                      v-model="schedule.weekly"
                    />
                    <span class="switch-slider"></span>
                  </label>

                  <Tooltip :title="`Select day of the week & time of the selected day when weekly backup to be selected`"  />
                </div>
              </div>
            </div>

            <div class="row py-3 border-bottom">
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <div>Fortnight</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <div class="d-flex align-items-center">
                      <!-- <div class="input-container">
                        <input
                          :disabled="!schedule.fortnight"
                          v-model="cronTimer.fortnight.startDate"
                          v-on:change="onChangeDate($event)"
                          type="date"
                          placeholder="01/06/2019"
                        />
                      </div>-->
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="cronTimer.fortnight.startDate"
                            v-on:click="clearSelectedDate()"
                          >✖</button>
                          <Datepicker :monday-first="true"
                            ref="programaticOpen"
                            :disabled="!schedule.fortnight"
                            v-model="cronTimer.fortnight.startDate"
                            @selected="onChangeDate($event)"
                            name="uniquename"
                          ></Datepicker>
                          <label
                            :class="typeof cronTimer.fortnight.startDate === 'object' ? 'active': ''"
                          >Start Date</label>
                        </div>
                      </div>
                      <Tooltip :title="`Select the folder where you want to store all backups for Brij`" 
                  :src="`school-calendar.svg`" />
                    </div>
                    <p v-if="submitted && schedule.fortnight" class="error_message">{{ errmsg }}</p>
                  </div>

                  <div class="col-md-6 mb-3">
                    <div class="d-flex align-items-center">
                      <div class="input-container">
                        <input
                          disabled="true"
                          v-model="cronTimer.fortnight.endDate"
                          type="text"
                          placeholder="01/06/2019"
                        />
                      </div>
                      <Tooltip :title="`Select the folder where you want to store all backups for Brij`" 
                  :src="`school-calendar.svg`" />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="d-flex align-items-center">
                      <div class="input-container">
                        <input
                          :disabled="!schedule.fortnight"
                          v-model="cronTimer.fortnight.startTime"
                          type="text"
                          placeholder="16:30"
                        />
                      </div>
                      <Tooltip :title="`Select the folder where you want to store all backups for Brij`" 
                  :src="`clock.svg`" />
                    </div>
                    <p v-if="submitted && schedule.fortnight" class="error_message">{{ errmsg }}</p>
                  </div>

                  <div class="col-md-6">
                    <div class="d-flex align-items-center">
                      <div class="input-container">
                        <input
                          :disabled="true"
                          v-model="cronTimer.fortnight.startTime"
                          type="text"
                          placeholder="16:30"
                        />
                      </div>
                      <Tooltip :title="`Select the folder where you want to store all backups for Brij`" 
                  :src="`clock.svg`" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <div class="d-flex justify-content-center align-items-center">
                  <label class="ios-switch">
                    <input
                      id="name_3"
                      type="checkbox"
                      class="ios-checkbox"
                      v-on:change="onChangeStatus($event,'fortnight')"
                      v-model="schedule.fortnight"
                    />
                    <span class="switch-slider"></span>
                  </label>

                  <Tooltip :title="`Select two date with 15 days gap & their respective back up time`"  />
                </div>
              </div>
            </div>

            <div class="row py-3 border-bottom">
              <div class="col-md-4">
                <div class="d-flex">
                  <div>Monthly</div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <div class="add-datepicker">
                      <button
                        class="btn-clearDate"
                        v-if="cronTimer.monthly.date"
                        v-on:click="clearSelectedDate()"
                      >✖</button>
                      <Datepicker :monday-first="true"
                        ref="programaticOpen"
                        :disabled="!schedule.monthly"
                        v-model="cronTimer.monthly.date"
                        name="uniquename"
                      ></Datepicker>
                      <label
                        :class="typeof cronTimer.monthly.date === 'object' ? 'active': ''"
                      >Select Date</label>
                    </div>
                  </div>

                  <!-- <div class="input-container">
                    <input
                      :disabled="!schedule.monthly"
                      v-model="cronTimer.monthly.date"
                      type="text"
                      placeholder="31/06/2019"
                    />
                  </div>-->
                  <Tooltip :title="`Select the folder where you want to store all backups for Brij`" 
                  :src="`school-calendar.svg`" />
                </div>
                <p v-if="submitted && schedule.monthly" class="error_message">{{ errmsg }}</p>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="input-container">
                    <input
                      :disabled="!schedule.monthly"
                      v-model="cronTimer.monthly.time"
                      type="text"
                      placeholder="23:30"
                    />
                  </div>
                  <Tooltip :title="`Select the folder where you want to store all backups for Brij`" 
                  :src="`clock.svg`" />
                </div>
                <p v-if="submitted && schedule.monthly" class="error_message">{{ errmsg }}</p>
              </div>

              <div class="col-md-2">
                <div class="d-flex justify-content-center align-items-center">
                  <label class="ios-switch">
                    <input
                      id="name_4"
                      type="checkbox"
                      class="ios-checkbox"
                      v-on:change="onChangeStatus($event,'monthly')"
                      v-model="schedule.monthly"
                    />
                    <span class="switch-slider"></span>
                  </label>

                  <Tooltip :title="`Select the date & time of the month when backup to be scheduled`"  />
                </div>
              </div>
            </div>

            <div class="row py-3 border-bottom">
              <div class="col-md-4">
                <div class="d-flex">
                  <div>Auto</div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center"></div>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center"></div>
              </div>

              <div class="col-md-2">
                <div class="d-flex justify-content-center align-items-center">
                  <label class="ios-switch">
                    <input
                      id="name_5"
                      type="checkbox"
                      class="ios-checkbox"
                      v-on:change="onChangeStatus($event,'auto')"
                      v-model="schedule.auto"
                    />
                    <span class="switch-slider"></span>
                  </label>

                  <Tooltip :title="`The backup will be scheduled automatically`"  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 text-center">
            <router-link to="select-installation-type" class="btn-outline-blue-lg w-25 mr-2">Back</router-link>
            <router-link
              v-on:click.native="onClickProceed()"
              to="#"
              class="btn-blue-lg w-25 ml-2"
            >Proceed</router-link>
            <!-- to="setup-organization" -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import CheckConnectionService from "@/services/CheckConnectionService.js";
import moment from "moment";
// import fs from "file-system";
// import $ from "jquery";
import saveState from "vue-save-state";

export default {
  name: "Backup Configuration",
  mixins: [saveState],
  data() {
    return {
      errmsg: "",
      submitted: false,
      filePath: "Downloads",
      selectedSchedule: "daily",
      selectedDay: "",
      schedule: {
        daily: true,
        weekly: false,
        fortnight: false,
        monthly: false,
        auto: false
      },
      cronTimer: {
        daily: {
          time: ""
        },
        weekly: {
          day: "",
          time: "",
          weekArray: [
            // "Sunday",
            // "Monday",
            // "Tuesday",
            // "Wednesday",
            // "Thrusday",
            // "Friday",
            // "Saturday"
          ]
        },
        fortnight: {
          startDate: "",
          endDate: "",
          startTime: "",
          endTime: ""
        },
        monthly: {
          date: "",
          time: ""
        }
      },
      errorMessage: ""
    };
  },

  mounted() {
    this.getWeekDays();
  },

  methods: {
    getWeekDays: function() {
      let payload = {
        tableName: "ms_week_days",
        wd_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.cronTimer.weekly.weekArray = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getSaveStateConfig() {
      return {
        cacheKey: "Backup Configuration"
      };
    },
    onClickProceed: function() {
      this.submitted = true;
      Object.keys(this.cronTimer[this.selectedSchedule]).map(x => {
        console.log("x :", x);
        console.log("this.selectedSchedule :", this.selectedSchedule);
        if (this.cronTimer[this.selectedSchedule][x] == "") {
          this.errmsg = "Please Select Mandatory Fields.";
          // alert("error");
          return;
        } else {
          // let index = this.cronTimer.weekly.weekArray.indexOf(
          //   this.cronTimer.weekly.day
          // );
          // this.cronTimer.weekly.day = this.cronTimer.weekly.weekArray[index];
          let payload = {
            filePath: this.filePath || "Downloads",
            cronDetails: this.cronTimer[this.selectedSchedule],
            scheduleType: this.selectedSchedule
          };
          CheckConnectionService.OnCreateBackup(payload)
            .then(response => {
              const { data } = response;
              if (data.Status) {
                this.$router.push({
                  path: "setup-organization"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(error => {
              this.$toasted.show(error);
            });
        }
      });
    },
    onSelectDay: function(event, day, dayIndex) {
      this.cronTimer.weekly.day = day.wd_id;
      this.selectedDay = day.wd_day;
    },
    clearSelectedDate: function() {
      this.cronTimer.fortnight.startDate = null;
    },
    onChangeDate: function(e) {
      let dateObject = e;
      let numberOfDaysToAdd = 15;
      // // this.cronTimer.fortnight.startDate = _dateObject;
      // dateObject.setDate(dateObject.getDate() + numberOfDaysToAdd);
      // let dd = dateObject.getDate();
      // let mm = dateObject.getMonth() + 1;
      // let y = dateObject.getFullYear();
      // console.log("_dateObject :", dateObject);

      // this.cronTimer.fortnight.endDate = dd + "/" + mm + "/" + y;
      this.cronTimer.fortnight.endDate = moment(new Date(dateObject)).add(
        numberOfDaysToAdd,
        "days"
      );
    },
    getfolder: function(e) {
      var files = e.target.files;
      var path = files[0].webkitRelativePath;
      var Folder = path.split("/");
      this.filePath = files[0].path || path;
    },
    onChangeStatus: function(event, name) {
      this.selectedSchedule = name;
      Object.keys(this.schedule).map(x => {
        if (x !== name) {
          this.schedule[x] = false;
        }
      });
    }
  }
};
</script>

  


// WEBPACK FOOTER //
// src/components/Installation/backupConfiguration.vue